import Vue from "vue";

export default {
  data() {
    return {
      isWufooLoading: false
    };
  },
  methods: {
    RemovePOBOX(address) {
      if (address != null) {
        address = address.replace(/\s\s+/g, " ");
        address = address.replace(/PO BOX/gi, "");
        address = address.replace(/POBOX/gi, "");
        address = address.replace(/P.O.BOX/gi, "");
        address = address.replace(/P.O..BOX/gi, "");
        address = address.replace(/P.O.BOX:/gi, "");
        address = address.replace(/P.O..BOX:/gi, "");
        address = address.replace(/P.O.BOX\./gi, "");
        address = address.replace(/P.O..BOX\./gi, "");
        address = address.trim();
        return address;
      } else {
        return null;
      }
    },
    checkIfAddressHasPO_BOX(address) {
      if (address != null) {
        if (address.match(/\s\s+/g, " ")) return true;
        if (address.match(/\s\s+/g, " ")) return true;
        if (address.match(/PO BOX/gi, "")) return true;
        if (address.match(/POBOX/gi, "")) return true;
        if (address.match(/P.O.BOX/gi, "")) return true;
        if (address.match(/P.O..BOX/gi, "")) return true;
        if (address.match(/P.O.BOX:/gi, "")) return true;
        if (address.match(/P.O..BOX:/gi, "")) return true;
        if (address.match(/P.O.BOX\./gi, "")) return true;
        if (address.match(/P.O..BOX\./gi, "")) return true;
        return false;
      } else {
        return false;
      }
    },
    FormatDate(value) {
      if (value != null) {
        var dateTime = value.split("T");
        var datePart = dateTime[0].split("-");
        var time = dateTime[1].split(".");
        return (
          datePart[1] +
          "/" +
          datePart[2] +
          "/" +
          datePart[0] +
          " " +
          this.ConvertTime(time[0])
        );
      } else {
        return null;
      }
    },
    FormatDateToLocal(value) {
      //2018-08-13T08:05:03.147
      var dsUTC = new Date(value); // Convert to date
      var newDsUTC =
        dsUTC.getMonth() +
        1 +
        "/" +
        dsUTC.getDate() +
        "/" +
        dsUTC.getFullYear() +
        " " +
        dsUTC.getHours() +
        ":" +
        dsUTC.getMinutes() +
        ":" +
        dsUTC.getSeconds();
      var ds = new Date(newDsUTC + " UTC"); // Convert from UTC to local date
      var getTime =
        this.PadLeftZero(ds.getHours()) +
        ":" +
        this.PadLeftZero(ds.getMinutes()) +
        ":" +
        this.PadLeftZero(ds.getSeconds());

      return (
        ds.getMonth() +
        1 +
        "/" +
        ds.getDate() +
        "/" +
        ds.getFullYear() +
        " " +
        this.ConvertTime(getTime)
      );
    },
    PadLeftZero(value) {
      if (value < 10) {
        return "0" + value;
      } else return value;
    },
    ConvertTime(time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? "AM" : "PM";
        time[0] = +time[0] % 12 || 12;
      }
      return time.join("");
    },
    G_NumberCheck(evt) {
      console.log('G_NumberCheck(evt) => ', evt);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    G_NumberInputCheck(element) {
      if (element.NumberOfJobs < 0 || element.NumberOfJobs == ".") {
        element.NumberOfJobs = null;
      }
    },
    // option is case sensitive
    G_NumberOfYearsCheck(element, option) {
      if (option == "YearsInPractice") {
        if (element.YearsInPractice < 1 || element.YearsInPractice == ".")
          element.YearsInPractice = null;
        else {
        }
        // element.YearsInPractice = input;
      } else if (option == "YearsInpractice") {
        if (element.YearsInpractice < 1 || element.YearsInpractice == ".")
          element.YearsInpractice = null;
        else {
        }
        // element.YearsInpractice = input;
      } else if (option == "yearsInPractice") {
        if (element.yearsInPractice < 1 || element.yearsInPractice == ".")
          element.yearsInPractice = null;
        else {
        }
        // element.yearsInPractice = input;
      } else {
        if (element < 1 || element == ".") element = null;
        else {
        }
        // element = input;
      }
    },
    IsNull(str) {
      if (str == null) return "";
      return str;
    },
    IsEmpty(params) {
      if (params != "") return params + ", ";
      return params;
    },
    G_CheckPasswordDigits(password) {
      if (password) {
        if (password.length > 0) {
          if (password.length < 6) {
            return {
              error: true,
              message: "Password must be at least 6 characters long"
            };
          } else {
            return {
              error: false,
              message: ""
            };
          }
        }
      }
    },
    G_CheckMatchPassword(password, passwordConfirm) {
      if (password && passwordConfirm) {
        if (password.length > 0 && passwordConfirm.length > 0) {
          if (password == passwordConfirm) {
            return [
              { error: false, message: "" },
              { error: false, message: "" }
            ];
          } else {
            return [
              { error: true, message: "" },
              { error: true, message: "Password does not match" }
            ];
          }
        }
      }
      return [];
    },
    G_CheckMatchCurrentPassword(currentPassword, newPassword) {
      if (currentPassword && newPassword) {
        if (currentPassword.length > 0 && newPassword.length > 0) {
          if (currentPassword == newPassword) {
            return {
              error: true,
              message: "New password is same as current password"
            };
          } else {
            return {
              error: false,
              message: ""
            };
          }
        }
      }
    },
    ConvertToTitleCase(stringToConvert) {
      var convertedString = stringToConvert
        .toLowerCase()
        .split(" ")
        .map(function(item) {
          // return item.charAt(0).toUpperCase() + item.substring(1);
          return item.replace(/\b[a-zA-Z]/, c => c.toUpperCase());
        })
        .join(" ");

      return convertedString;
    },
    G_CheckYearLicense(input) {
      var date = new Date();
      if (input.length < 4) {
        return "Year licensed must be valid";
      } else if (input > date.getFullYear()) {
        return "Year licensed must be equal or less than current year";
      } else return "";
    },
    G_ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
    },
    G_ShowCovidReliefModal() {
      this.isCovidReliefModalShown = !this.isCovidReliefModalShown; // todo try to setup global function
    },
    G_CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    G_ProcessLogin(response) {
      var _this = this;
      if (response.data.isSuccess == true) {
        localStorage.setItem("host", response.data.raw.username);
        localStorage.setItem("token", response.data.raw.token);
        localStorage.setItem("watchword", response.data.raw.password);
        localStorage.setItem("accountStatus", response.data.raw.accountStatus);
        var crps = response.data.raw.covidReliefParticipantStatus || undefined;
        // covid program
        console.log("set covidReliefParticipantStatus")
        console.log("covidReliefParticipantStatus", crps)

        localStorage.setItem("covidReliefParticipantStatus", crps);
        localStorage.setItem(
          "frameAndLensOrderIsAllowed",
          response.data.raw.frameAndLensOrderIsAllowed
        );



        localStorage.setItem(
          "PersistentNotificationMessage",
          response.data.raw.persistentNotification
        );
        var pNotification = localStorage.getItem(
          "PersistentNotificationMessage"
        );

        if (pNotification == "") {
          localStorage.setItem("ShowPersistentNotification", false);
        }
        if (pNotification != "") {
          localStorage.setItem("ShowPersistentNotification", true);
        }
        var shippingAddress = {
          shippingAddressLineOne: response.data.raw.shippingAddressLineOne,
          shippingAddressLineTwo: response.data.raw.shippingAddressLineTwo,
          shippingCity: response.data.raw.shippingCity,
          shippingState: response.data.raw.shippingState,
          shippingPostalCode: response.data.raw.shippingPostalCode
        };

        localStorage.setItem(
          "shippingAddress",
          JSON.stringify(shippingAddress)
        );

        var sponsors = {
          minorLogos: [
            response.data.raw.logoMinorSponsor1,
            response.data.raw.logoMinorSponsor2,
            response.data.raw.logoMinorSponsor3
          ],
          majorLogo: response.data.raw.logoMajorSponsorSmall,
          majorLogoLg: response.data.raw.logoMajorSponsorLarge,
          header: response.data.raw.logoMajorSponsorHeader,
          paragraph: response.data.raw.logoMajorSponsorParagraph,
          hyperLinkMinor: [
            response.data.raw.firstMinorSponsorLogoHyperlink,
            response.data.raw.secondMinorSponsorLogoHyperlink,
            response.data.raw.thirdMinorSponsorLogoHyperlink
          ],
          hyperLinkMajor: response.data.raw.majorSponsorLogoHyperlink
        };
        localStorage.setItem("sponsors", JSON.stringify(sponsors));

        var targetURL = localStorage.getItem("nextURL");
        if (targetURL != null) {
          _this.$router.push(targetURL);
        } else {
          _this.$router.push({ name: "PortalHome" });
        }
      } else {
        var index = response.data.errorMessage.indexOf("activation");
        if (
          response.data.errorMessage == "Outdated" ||
          response.data.errorMessage == "AnnualForecastRequired"
        ) {
          localStorage.setItem("email", _this.Account.EmailAddress);
          localStorage.setItem("password", _this.Account.Password);
          localStorage.setItem("accountType", response.data.raw.accountType);
          localStorage.setItem("accountStatus", response.data.raw.accountStatus);
          localStorage.setItem(
            "isCoveredUnderHIPAA",
            response.data.raw.isCoveredUnderHIPAA
          );
          localStorage.setItem("name", response.data.raw.name);
          localStorage.setItem("salesforceId", response.data.raw.salesforceId);
          localStorage.setItem(
            "frameAndLensOrderIsAllowed",
            response.data.raw.frameAndLensOrderIsAllowed
          );
          _this.$router.push({
            name:
              response.data.errorMessage == "Outdated"
                ? "ContractAgreement"
                : "AnnualForecasting",
            params: { salesforceId: response.data.raw.salesforceId }
          });
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/GlobalFunctions.js